import { Action } from '@ngrx/store';

export const ENABLE_ACCOUNT_SUCCESS = '[Customer] User Enable Account Success';

export class EnableAccountSuccessAction implements Action {
  readonly type = ENABLE_ACCOUNT_SUCCESS;

  constructor(public payload: { user: { key: string, identifier: string }, status: string }) {}
}



// WEBPACK FOOTER //
// ./src/app/customer/store/actions/EnableAccountSuccessAction.ts